import { render, staticRenderFns } from "./wx_login.vue?vue&type=template&id=460758b3"
import script from "./wx_login.vue?vue&type=script&lang=js"
export * from "./wx_login.vue?vue&type=script&lang=js"
import style0 from "./wx_login.vue?vue&type=style&index=0&id=460758b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports